import {
  LOAD_WORK_GROUPS_REQUEST, LOAD_WORK_GROUPS_SUCCESS, LOAD_WORK_GROUPS_FAIL,
  POST_WORK_GROUP_REQUEST, POST_WORK_GROUP_SUCCESS, POST_WORK_GROUP_FAIL,
  PUT_WORK_GROUP_REQUEST, PUT_WORK_GROUP_SUCCESS, PUT_WORK_GROUP_FAIL,
  DELETE_WORK_GROUP_REQUEST, DELETE_WORK_GROUP_SUCCESS, DELETE_WORK_GROUP_FAIL
} from 'src/store/actions/workGroupsActions';

const initialState = {
  list: [],
  options: [],
  loadFetching: false,
  createFetching: false,
  updateFetching: false,
  deleteFetching: false
};

const listToOptions = (list) => list.map(({ Id, Name }) => ({ label: Name, value: `${Id}` }));

const workGroupsReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_WORK_GROUPS_REQUEST:
      return ({ ...state, loadFetching: true });
    case POST_WORK_GROUP_REQUEST:
      return ({ ...state, createFetching: true });
    case PUT_WORK_GROUP_REQUEST:
      return ({ ...state, updateFetching: true });
    case DELETE_WORK_GROUP_REQUEST:
      return ({ ...state, deleteFetching: true });
    case LOAD_WORK_GROUPS_SUCCESS:
      return ({
        ...state,
        loadFetching: false,
        list: action.data,
        options: listToOptions(action.data)
      });
    case POST_WORK_GROUP_SUCCESS: {
      const newList = [...state.list, action.data];
      return ({
        ...state,
        createFetching: false,
        list: newList,
        options: listToOptions(newList)
      });
    }
    case PUT_WORK_GROUP_SUCCESS: {
      const newList = state.list.map((workShift) => (workShift.Id === action.data.Id ? action.data : workShift));
      return ({
        ...state,
        updateFetching: false,
        list: newList,
        options: listToOptions(newList)
      });
    }
    case DELETE_WORK_GROUP_SUCCESS: {
      const newList = state.list.filter((workShift) => workShift.Id !== action.data.Id);
      return ({
        ...state,
        deleteFetching: false,
        list: newList,
        options: listToOptions(newList)
      });
    }
    case LOAD_WORK_GROUPS_FAIL:
      return ({ ...state, loadFetching: false });
    case POST_WORK_GROUP_FAIL:
      return ({ ...state, createFetching: false });
    case PUT_WORK_GROUP_FAIL:
      return ({ ...state, updateFetching: false });
    case DELETE_WORK_GROUP_FAIL:
      return ({ ...state, deleteFetching: false });
    default:
      return state;
  }
};

export default workGroupsReducer;
